export default __webpack_public_path__ + "static/client5-67dbd075f067a482b749a9dca2a7e4c6.jpeg";